import { render, staticRenderFns } from "./ViewContainer.vue?vue&type=template&id=05c9fe97&"
import script from "./ViewContainer.vue?vue&type=script&lang=js&"
export * from "./ViewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports